import { nextTick, onMounted, ref } from 'vue';

export const useMountedState = () => {
	const done = ref(false);

	onMounted(() => nextTick(() => (done.value = true)));

	return done;
};
